var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.71525,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "none",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9905 23.0002H23M22.9905 23.0002C22.3678 23.6177 21.2393 23.4639 20.4479 23.4639C19.4765 23.4639 19.0087 23.6539 18.3154 24.3472C17.7251 24.9376 16.9337 26.0002 16 26.0002C15.0663 26.0002 14.2749 24.9376 13.6846 24.3472C12.9913 23.6539 12.5235 23.4639 11.5521 23.4639C10.7607 23.4639 9.63218 23.6177 9.00949 23.0002C8.38181 22.3778 8.53628 21.2446 8.53628 20.4481C8.53628 19.4416 8.31616 18.9788 7.59938 18.262C6.53314 17.1958 6.00002 16.6626 6 16.0002C6.00001 15.3377 6.53312 14.8046 7.59935 13.7384C8.2392 13.0985 8.53628 12.4645 8.53628 11.5522C8.53628 10.7608 8.38249 9.63232 9 9.00962C9.62243 8.38196 10.7556 8.53644 11.5521 8.53644C12.4643 8.53644 13.0983 8.23938 13.7381 7.59955C14.8044 6.5333 15.3375 6.00018 16 6.00018C16.6625 6.00018 17.1956 6.5333 18.2618 7.59955C18.9015 8.23925 19.5355 8.53644 20.4479 8.53644C21.2393 8.53644 22.3679 8.38265 22.9906 9.00018C23.6182 9.62261 23.4637 10.7558 23.4637 11.5522C23.4637 12.5588 23.6839 13.0216 24.4006 13.7384C25.4669 14.8046 26 15.3377 26 16.0002C26 16.6626 25.4669 17.1958 24.4006 18.262C23.6838 18.9788 23.4637 19.4416 23.4637 20.4481C23.4637 21.2446 23.6182 22.3778 22.9905 23.0002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.8929C13 16.8929 14.2 17.5447 14.8 18.5C14.8 18.5 16.6 14.75 19 13.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOutline);
export default __webpack_public_path__ + "static/media/checkmarkOutline.00e847abb45e544b59f53f60645a36ad.svg";
export { ForwardRef as ReactComponent };